import { InjectionToken } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Drawing } from '@textbook-api-client/lib/interface/drawing.model';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { TxtbAction } from '../../internal/state/txtb-action';
import { WindowOrientation } from '../../internal/actions/@base/services';
import { ActionNote } from '@textbook-api-client/lib/interface/action-note.model';
import { SingleNote } from '@textbook-api-client/lib/interface/single-note.model';

export interface TextbookActionsHandler {
  readonly isEditorPreviewMode: boolean;
  readonly isCanvasDirty$: BehaviorSubject<boolean>;
  readonly isBasicUserModalOpen$ubject: BehaviorSubject<boolean>;
  readonly isExternalLinkModalOpen$ubject: BehaviorSubject<boolean>;
  readonly isActionRestrictedInOffline$ubject: BehaviorSubject<boolean>;
  readonly pageNumber$ubject: BehaviorSubject<number>;
  readonly txtbActions$ubject: Subject<TxtbAction>;
  readonly overwriteTxtbAction$ubject: ReplaySubject<TxtbAction>;
  readonly isPremiumAccess$: Observable<boolean>;
  readonly playerType$: Observable<string>;
  readonly accessId$: Observable<number>;
  readonly currentPageNumber$: Observable<number | null>;
  readonly currentActionPageNumber$: Observable<number | null>;
  readonly currentDeviceOS$: Observable<string | null>;
  readonly selectZoomPercentage$: Observable<number | null>;
  readonly windowOrientation$: Observable<WindowOrientation | null>;
  readonly isReadonlyMode$: Observable<boolean>;
  readonly isMobileApp: boolean;

  redirectToTextbookPage(textbookId: string, page: number): Promise<boolean>;

  redirectToExternalUrl(url: string): void;

  backToTextbook(currentRoute: ActivatedRoute): Promise<boolean>;

  redirectToAction(actionId: string, currentRoute: ActivatedRoute): Promise<boolean>;

  createDrawing$(accessId: number, actionId: string, content: string): Observable<Drawing>;

  getDrawings$(): Observable<Drawing[]>;

  getActionDrawing$(actionId: string): Observable<Drawing>;

  updateDrawing$(drawingId: string, accessId: number, content: string): Observable<Drawing>;

  deleteDrawing$(drawingId: string, accessId: number): Observable<any>;

  createActionNote$(
    accessId: number,
    actionId: string,
    notes: SingleNote[]
  ): Observable<ActionNote>;

  updateActionNote$(
    actionNoteId: string,
    accessId: number,
    notes: SingleNote[]
  ): Observable<ActionNote>;

  deleteActionNote$(noteId: string, accessId: number): Observable<any>;

  getAllActionNotes$(): Observable<ActionNote[]>;

  getActionNote$(actionId: string): Observable<ActionNote>;

  getResourceUrl$(resourceId: string): Observable<string>;

  getResourceBlobAsString(resourceId: string): Observable<string>;
}

export const TextbookActionsHandlerToken = new InjectionToken<TextbookActionsHandler>(
  'TxtbActionsHandler'
);

export { TxtbAction };
